import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { h as handleDismiss } from './p-CY_xCDya.js';
import { g as getAlertOrBannerIcon } from './p-4eps5r2r.js';
import { d as defineCustomElement$5 } from './p-B7ipNcUy.js';
import { d as defineCustomElement$4 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$3 } from './p-CFAyJ2yW.js';
import { d as defineCustomElement$2 } from './p-ClSUnmWE.js';

const alertCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;border:none;border-radius:.375rem;box-sizing:border-box;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem;padding:.75rem 1rem;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.content{align-items:flex-start;display:inline-flex;gap:.75rem;width:100%}.content wui-icon{margin:.125rem 0}:host([type=info]){background-color:var(--jw-theme-info-muted-message-bg-color);color:var(--jw-theme-info-muted-message-color)}:host([type=info]) ::slotted(a),:host([type=info]) ::slotted(a:hover){--color:var(--jw-theme-info-muted-message-color)!important;color:var(--color)!important}:host([type=error]){background-color:var(--jw-theme-error-muted-message-bg-color);color:var(--jw-theme-error-muted-message-color)}:host([type=error]) ::slotted(a),:host([type=error]) ::slotted(a:hover){--color:var(--jw-theme-error-muted-message-color)!important;color:var(--color)!important}:host([type=warning]){background-color:var(--jw-theme-warning-muted-message-bg-color);color:var(--jw-theme-warning-muted-message-color)}:host([type=warning]) ::slotted(a),:host([type=warning]) ::slotted(a:hover){--color:var(--jw-theme-warning-muted-message-color)!important;color:var(--color)!important}:host([type=success]){background-color:var(--jw-theme-success-muted-message-bg-color);color:var(--jw-theme-success-muted-message-color)}:host([type=success]) ::slotted(a),:host([type=success]) ::slotted(a:hover){--color:var(--jw-theme-success-muted-message-color)!important;color:var(--color)!important}:host([type=promo]){background-color:var(--jw-theme-promo-bg-color);border-bottom:2px solid var(--jw-theme-promo-border-color);color:var(--jw-theme-promo-text-color)}:host([type=promo]) ::slotted(a),:host([type=promo]) ::slotted(a:hover){--color:var(--jw-theme-promo-text-color)!important;color:var(--color)!important}:host([type=promo]) hr{background-color:var(--jw-theme-surface-muted-message-divider)}:host([type=promo]) .content{gap:.5rem}:host([type=promo]) h5{min-width:fit-content}h5{color:var(--jw-theme-promo-label-color);margin:0;padding:0}.actions{align-items:center;display:flex;gap:.75rem;justify-content:center}.actions hr{background-color:var(--jw-theme-surface-muted-message-divider);border:none;height:24px;width:1px}";

const WuiAlert$1 = /*@__PURE__*/ proxyCustomElement(class WuiAlert extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dismiss = createEvent(this, "dismiss", 3);
        //////// DISMISSIBLE START ////////
        this.dismissible = true;
        this.handleDismiss = () => handleDismiss(this);
        //////// DISMISSIBLE END ////////
        /**
         * Style of alert (green/blue/orange/red)
         */
        this.type = 'info';
        /**
         * Label to replace default 'NEW!' (promo only)
         */
        this.promoLabel = 'NEW! 🎉';
    }
    render() {
        const icon = getAlertOrBannerIcon(this.type);
        return (h(Host, { key: '2d6fcd8befa19e4b4529b744427d77e558ce2a03' }, h("div", { key: '14db2dfa5888664d915ab33874f50c2cf79f27c7', class: "content" }, this.type === 'promo' ? h("h5", null, this.promoLabel) : icon ? h("wui-icon", { size: "md", name: icon }) : undefined, h("div", { key: 'd47c89cd6e7deeaca79273d0b039f3c0e0ad9196' }, h("slot", { key: '2e96539d97534745e1b38c45cdc92ba59547d82b' }))), this.dismissible && (h("div", { key: 'ec60f4606ceb3f961ecfe0b3b627647eb019c287', class: "actions" }, h("hr", { key: 'f894db454e750c4caf14354e87d1597145685d17' }), h("wui-close-button", { key: '88cea73c20287733ffd5b864863565e4c2395078', onClick: this.handleDismiss, type: this.type === 'promo' ? 'bold' : 'muted' })))));
    }
    get elm() { return this; }
    static get style() { return alertCss; }
}, [257, "wui-alert", {
        "dismissible": [4],
        "type": [513],
        "promoLabel": [1, "promo-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-alert", "wui-close-button", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-alert":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiAlert$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiAlert = WuiAlert$1;
const defineCustomElement = defineCustomElement$1;

export { WuiAlert, defineCustomElement };
